import api from '../../api'
const contador = {
    namespaced: true,
    state: () => ({
        activeRoute: '',
        filter_current_contador: '',
        contadores: [],
    }),
    mutations: {
        currentFilter(state, data) {
            state.filter_current_contador = data;

           
        },
        setActive(state, data) {
            //  console.log("data contadores", data);



            state.activeRoute = data.current_route;
            state.contadores = data.contadores;

            //console.log("adicionei os contadores", state.contadores);
        }
    },
    actions: {
        async getContador({ state, commit }, route = "") {
            let current_route = "";
            if (route == "")
                current_route = state.activeRoute;
            else {
                current_route = route;
            }
            if (current_route) {
                const contadores = await api.get(current_route);

                commit("setActive", { current_route, contadores: contadores.data });
            }
        }
    }, // promise axios
    getters: {} //computer
}


export default contador;